import gsap from 'gsap'

export default function(){
	function myMenuDesktop(){
		// DESKTOP SCRIPT
	
		// Header color theme
		const siteHeaderLogo = document.querySelector( '.top-nav .top-nav__logo' )
	
		if ( siteHeaderLogo.classList.contains( 'logo-red' ) ){
			document.querySelector( 'body' ).classList.add( 'header-red' )
		} else if ( siteHeaderLogo.classList.contains( 'logo--white' ) ){
			document.querySelector( 'body' ).classList.add( 'header-white' )
		}
	
		// Variables
		const html = document.querySelector('html')
		const body = document.querySelector('body')
		const header = document.querySelector('.top-nav')
		const hamburger = document.querySelector('.top-nav .hamburger-menu')
		const panelLeft = document.querySelector('.top-nav .menu-panel__left')
		const panelRight = document.querySelector('.top-nav .menu-panel__right')
		const panelBottom = document.querySelector('.top-nav .menu-panel__bottom')
	
		let panelLeftWidth = '60vw'
		let panelRightWidth = '40vw'
		let logoWasChanged = false
	
		// Controls the menu open/close functionality
		function mainMenuOpenClose(){
			const allSubMenus = document.querySelectorAll( '.top-nav .sub-menu' )
			const isThereNotifications = document.querySelector( '.notification.popup' )
	
			html.classList.toggle('menu-open')
			body.classList.toggle('menu-open')
			header.classList.toggle('open')
	
			if ( header.classList.contains( 'open' ) ) {
				// We open the menu
				gsap.to( panelLeft, { left: 0, duration: 0.7, ease: 'power2.out' } )
				gsap.to( panelBottom, { bottom: 0, opacity: 1, pointerEvents: 'auto', ease: 'power2.out' } )
	
				// We change the logo if needed (and hide it if there is notification active)
				if ( siteHeaderLogo.classList.contains( 'logo-red' ) ) {
					siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--red', 'logo--white' )
					logoWasChanged = true
				}
				if ( isThereNotifications ){
					siteHeaderLogo.querySelector('img').style.visibility = 'hidden'
				}
	
				// We check if a item from the secondary meny is open and add opacity to the main menu
				if ( document.querySelector( '#secondary-menu li.current-page-ancestor' ) ){
					document.querySelector( '.menu-main-menu-container' ).style.opacity = 0.5
				}
	
	
	
				// We "open" all of the submenus to have them available without a sliding animation, but we hide them
				allSubMenus.forEach( subMenu => {
					gsap.set( subMenu, { right: 0, opacity: 0, pointerEvents: 'none', duration: 0 } )
				})
	
				/*
				We check if a page in the submenu is active.
				If so, we open the menu with that submenu visible.
				*/
				const currentPageItem = document.querySelector( '.top-nav .sub-menu li.current-page-item' )
				const currentPageAncestorSecondLevel = document.querySelector( '.top-nav #secondary-menu .sub-menu li.current-page-ancestor' )
	
				if ( currentPageItem ){
					let currentPageItemLink = currentPageItem.parentNode.parentNode
	
					// Open panel right, with subemenu open
					gsap.to( currentPageItemLink, { right: 0, opacity: 1, pointerEvents: 'auto', duration: 0.7, ease: 'power2.out' } )
	
					// Open the panel right to have a red background all the time
					gsap.to( panelRight, { right: 0, opacity: 1, pointerEvents: 'auto', duration: 0, delay: 1, ease: 'power2.out' } )
	
				} else  if ( currentPageAncestorSecondLevel ) {
					let currentPageItemLink = currentPageAncestorSecondLevel.parentNode.parentNode
	
					// Open panel right, with subemenu open
					gsap.to( currentPageItemLink, { right: 0, opacity: 1, pointerEvents: 'auto', duration: 0.7, ease: 'power2.out' } )
	
					// Open the panel right to have a red background all the time
					gsap.to( panelRight, { right: 0, opacity: 1, pointerEvents: 'auto', duration: 0, delay: 1, ease: 'power2.out' } )
				}else {
	
					// Open panel right, with no submenu open
					gsap.to( panelRight, { right: 0, opacity: 1, pointerEvents: 'auto', duration: 0.7, ease: 'power2.out' } )
	
				}
	
			} else {
				// We close the menu
				gsap.to( panelLeft, { left: '-' + panelLeftWidth, duration: 0.7, ease: 'power2.out' } )
				gsap.to( panelRight, { right: '-' + panelRightWidth, duration: 0.7, ease: 'power2.out' } )
				gsap.to( panelBottom, { bottom: '-100px', opacity: 0, pointerEvents: 'none', ease: 'power2.out' } )
	
				// We change the logo if needed (and show it if needed)
				if ( logoWasChanged ){
					siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--white', 'logo--red' )
				}
				if ( isThereNotifications ){
					siteHeaderLogo.querySelector('img').style.visibility = ''
				}
	
				// We restore the style of the main menu if a item from the secondary meny is open
				if ( document.querySelector( '#secondary-menu li.current-page-ancestor' ) ){
					document.querySelector( '.menu-main-menu-container' ).style.opacity = ''
				}
	
	
	
				// Close other submenus
				allSubMenus.forEach(item => {
					gsap.to( item, { right: '-' + panelRightWidth, duration: 0.7, ease: 'power2.out' } )
				});
	
				// Reset the active class on the menu items
				document.querySelectorAll('li.menu-item-has-children > a').forEach(item => {
					item.classList.remove('active')
					item.classList.remove('no-active')
				});
			}
		}
	
		function openSubmenu(link){
			const subMenu = link.parentNode.querySelector('.sub-menu')
			const allSubMenus = document.querySelectorAll( '.top-nav .sub-menu' )
	
			// Hide the first right hand side content to avoid weird effect on change opacity
			gsap.set( panelRight.querySelectorAll('*'), { opacity: 0, pointerEvents: 'none' } )
	
			// We remove the opacity on the main menu in case it was applied from a microsite (secondary menu active)
			document.querySelector( '.menu-main-menu-container' ).style.opacity = ''
	
			// Close other submenus
			allSubMenus.forEach(item => {
				//gsap.to( item, { right: '-' + panelRightWidth, duration: 0.7, ease: 'power2.out' } )
				gsap.to( item, { opacity: 0, pointerEvents: 'none', duration: 0.7, ease: 'power2.out' } )
			});
	
			if ( subMenu ){
				// Open submenu
				gsap.to( subMenu, { opacity: 1, pointerEvents: 'auto', duration: 0.7, ease: 'power2.out' } )
			}
		}
	
	
	
		/* Set up for screen heights and menu scrolling */
		function calculateMenuHeights (onResize){
			const mainMenu         = document.getElementById( 'main-menu' )
			const subMenu          = document.querySelector( '.sub-menu > .sub-menu-menu' )     // to do the calculations we just need one submenu
			const subMenus         = document.querySelectorAll( '.sub-menu > .sub-menu-menu' )  // but to apply the CSS we need all of them
			const subMenuWrapper   = document.querySelectorAll( '.sub-menu' )
			const windowHeight     = window.innerHeight
			const menuBottomHeight = document.querySelector( '.menu-panel__bottom' ).offsetHeight
	
			// Main menu height
			/* const mainMenuSpaceToTop = window.scrollY + mainMenu.getBoundingClientRect().top
	
			if ( mainMenu.offsetHeight > ( windowHeight - mainMenuSpaceToTop - menuBottomHeight ) ) {
				mainMenu.style.overflowY = 'auto'
				mainMenu.style.maxHeight = ( windowHeight - mainMenuSpaceToTop - menuBottomHeight ) + 'px'
			} */
	
	
			// Sub menus height
			subMenuWrapper.forEach(submenu => {
				submenu.style.maxHeight = ( windowHeight - menuBottomHeight ) + 'px'
			});
	
			const subMenuSpaceToTop         = window.scrollY + subMenu.getBoundingClientRect().top
			const subMenuSpacePaddingBottom = window.getComputedStyle(subMenuWrapper[0], null).getPropertyValue('padding-bottom').replace('px', '')
	
			subMenus.forEach(submenu => {
				if ( onResize ) {
					submenu.style.maxHeight = 'none'
				}
	
				if ( submenu.offsetHeight > ( windowHeight - menuBottomHeight - subMenuSpaceToTop - subMenuSpacePaddingBottom ) ) {
					submenu.style.overflowY = 'auto'
					submenu.style.maxHeight = ( windowHeight - menuBottomHeight - subMenuSpaceToTop - subMenuSpacePaddingBottom ) + 'px'
				}
			});
			
		}
	
	
		calculateMenuHeights(false)
	
		addEventListener("resize", (event) => { calculateMenuHeights(true) });
	
	
	
	
		/* Events */
	
		// Hamburger opens/close menu
		hamburger.addEventListener( 'click', function(){
			mainMenuOpenClose()
		} )
	
		// Open sub-menu on click
		// Prevent click on parent pages - 1lvl
		const parentLinksMainMenu = document.querySelectorAll('.top-nav .menu-main-menu-container > .menu > li.menu-item-has-children > a')
		const parentLinksSecondaryMenu = document.querySelectorAll('.top-nav .menu-secondary-menu-container > .menu > li.menu-item-has-children > a')
		const allParentLinks = [...parentLinksMainMenu, ...parentLinksSecondaryMenu]
		
		allParentLinks.forEach(element => {
			element.addEventListener( 'click', function(e){
				e.preventDefault()
	
				openSubmenu(element)
	
				// Mark current as active and others as inactive
				allParentLinks.forEach(element => {
					element.classList.remove( 'active' )
					element.classList.add( 'no-active' )
				});
				element.classList.add( 'active' )
				element.classList.remove( 'no-active' )
			} )
		});
	}
	function myMenuMobile(){
		//  MOBILE SCRIPT
	
		// Header color theme
		const siteHeaderLogo = document.querySelector( '.top-nav--mobile .top-nav__logo' )
	
		if ( siteHeaderLogo.classList.contains( 'logo-red' ) ){
			document.querySelector( 'body' ).classList.add( 'header-red' )
		} else if ( siteHeaderLogo.classList.contains( 'logo--white' ) ){
			document.querySelector( 'body' ).classList.add( 'header-white' )
		}
	
		// Variables
		const html = document.querySelector('html')
		const body = document.querySelector('body')
		const header = document.querySelector('.top-nav--mobile')
		const navHeader = document.querySelector('.top-nav--mobile__header')
		const hamburger = document.querySelector('.top-nav--mobile .hamburger-menu')
		const menuPanel = document.querySelector('.top-nav--mobile .menu-panel')
		const mainMenu = document.querySelector('.top-nav--mobile .menu-panel__top')
		const secondaryMenu = document.querySelector('.top-nav--mobile .menu-panel__bottom')
		const extraMenu = document.querySelector('.top-nav--mobile .menu-panel__extra')
	
		let logoWasChanged = false
	
	
		// Controls the menu open/close functionality
		function mainMenuOpenClose(){
			const allSubMenus = document.querySelectorAll( '.top-nav--mobile .sub-menu' )
	
			html.classList.toggle('menu-open')
			body.classList.toggle('menu-open')
			header.classList.toggle('open')
	
			if ( header.classList.contains( 'open' ) ) {
				// We open the menu
				gsap.to( menuPanel, { right: 0, duration: 0.7, ease: 'power2.out' } )
				setTimeout(() => {
					// If when the delay happend, the menu is still open, we apply the change
					// This way we avoid issues when the user clicks the button too quickly
					if ( header.classList.contains( 'open' ) ) {
						gsap.to( navHeader, { background: '#c20040', duration: 0 } )
					}
				}, 1000);
	
				// We change the logo if needed
				if ( siteHeaderLogo.classList.contains( 'logo-red' ) ) {
					siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--red', 'logo--white' )
					logoWasChanged = true
				}
	
				/*
				We check if a page in the submenu is active.
				If so, we open the menu with that submenu visible.
				*/
				const currentPageItem = document.querySelector( '.top-nav--mobile .sub-menu li.current-page-item' )
	
				if ( currentPageItem ){
					let currentPageItemLink = currentPageItem.parentNode.parentNode
	
					// Open panel right, with subemenu open
					gsap.to( currentPageItemLink, { right: 0, duration: 0.7, ease: 'power2.out' } )
	
				}
	
			} else {
				// We close the menu
				gsap.to( menuPanel, { right: '-100vw', duration: 0.7, ease: 'power2.out' } )
				gsap.to( allSubMenus, { right: '-100vw', duration: 0.7, ease: 'power2.out' } )
				gsap.to( navHeader, { background: 'transparent', duration: 0, delay: 0 } )
	
				if ( logoWasChanged ){
					siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--white', 'logo--red' )
				}
	
				// Reset the active class on the menu items
				document.querySelectorAll('li.menu-item-has-children > a').forEach(item => {
					item.classList.remove('active')
					item.classList.remove('no-active')
				});
			}
		}
	
		function openSubmenu(link){
			const subMenu = link.parentNode.querySelector('.sub-menu')
			const allSubMenus = document.querySelectorAll( '.top-nav--mobile .sub-menu' )
	
			// Close other submenus
			allSubMenus.forEach(item => {
				gsap.to( item, { right: '-100vw', duration: 0.7, ease: 'power2.out' } )
			});
	
			if ( subMenu ){
				// Open submenu
				gsap.to( subMenu, { right: 0, duration: 0.7, ease: 'power2.out' } )
			}
		}
		function closeSubmenu(link){
			// Closes all submenus
			//const subMenu = link.parentNode.parentNode
			const allSubMenus = document.querySelectorAll( '.top-nav--mobile .sub-menu' )
	
			// Close other submenus
			allSubMenus.forEach(item => {
				gsap.to( item, { right: '-100vw', duration: 0.7, ease: 'power2.out' } )
			});
		}
	
	
		/* Events */
	
		// Hamburger opens/close menu
		hamburger.addEventListener( 'click', function(){
			mainMenuOpenClose()
		} )
	
	
		// Open sub-menu on click
		// Prevent click on parent pages - 1lvl
		const parentLinksMainMenu = document.querySelectorAll('.top-nav--mobile .menu-main-menu-container > .menu > li.menu-item-has-children > a')
		const parentLinksSecondaryMenu = document.querySelectorAll('.top-nav--mobile .menu-secondary-menu-container > .menu > li.menu-item-has-children > a')
		const allParentLinks = [...parentLinksMainMenu, ...parentLinksSecondaryMenu]
		
		allParentLinks.forEach(element => {
			element.addEventListener( 'click', function(e){
				e.preventDefault()
	
				openSubmenu(element)
	
				// Mark current as active and others as inactive
				allParentLinks.forEach(element => {
					element.classList.remove( 'active' )
					element.classList.add( 'no-active' )
				});
				element.classList.add( 'active' )
				element.classList.remove( 'no-active' )
			} )
		});
	
	
	
		// Sub menu back button
		const backButtons = document.querySelectorAll( '.sub-menu .menu-back' )
	
		if ( backButtons.length > 0 ){
			backButtons.forEach(button => {
				button.addEventListener( 'click', function(){
					closeSubmenu(button)
				} )
			});
		}
	}
	function myMenu(){
		let itWasMobileScreenSize = isMobileScreenSize
		isMobileScreenSize = window.innerWidth < 1084

		if ( firstRun || itWasMobileScreenSize != isMobileScreenSize ) {
			if ( isMobileScreenSize ) {
				myMenuMobile()
			} else {
				myMenuDesktop()
			}
		}

		firstRun = false


		// Logo changes and fit banner image
		const siteHeaderLogo  = document.querySelector( '.top-nav--mobile .top-nav__logo' )
		const bannerTextImage = document.querySelector( '.banner.banner--text-image' )
		const bannerWithQuote = document.querySelector( '.banner.banner--with-quote' )
		const singlePost      = document.querySelector( 'body.single-post' )
		
		// Change logo color
		if ( ( bannerTextImage || bannerWithQuote) && window.innerWidth < 520 ){
			siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--red', 'logo--white' )
		}
		if ( ( singlePost ) && window.innerWidth < 828 ){
			siteHeaderLogo.querySelector('img').src = siteHeaderLogo.querySelector('img').src.replace( 'logo--red', 'logo--white' )
		}
	}

	let isMobileScreenSize = window.innerWidth < 1084
	let firstRun = true

	myMenu()

	window.addEventListener('resize', function() {
		myMenu()
	});
}
